"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION_DEFAULT = exports.MODAL_DEFAULT_WIDTH = exports.ICON_INFO = exports.DEVICE = exports.DEFAULT_LOCALE = exports.CARD_TEXT_DISPLAY = void 0;
var CARD_TEXT_DISPLAY = {
  MC: 'Mastercard',
  VI: 'VISA',
  BM: 'BigPay',
  AX: 'AMEX',
  JC: 'JCB',
  UP: 'UnionPay',
  MD: 'Master Debit',
  VH: 'Visa Debit'
};
exports.CARD_TEXT_DISPLAY = CARD_TEXT_DISPLAY;
var MODAL_DEFAULT_WIDTH = '400px';
exports.MODAL_DEFAULT_WIDTH = MODAL_DEFAULT_WIDTH;
var DEFAULT_LOCALE = 'en-gb';
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
var BREAKPOINTS = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px'
};
var DEVICE = {
  mobileS: "(max-width: ".concat(BREAKPOINTS.mobileS, ")"),
  mobileM: "(max-width: ".concat(BREAKPOINTS.mobileM, ")"),
  mobileL: "(max-width: ".concat(BREAKPOINTS.mobileL, ")"),
  tablet: "(min-width: ".concat(BREAKPOINTS.tablet, ")"),
  laptop: "(min-width: ".concat(BREAKPOINTS.laptop, ")"),
  laptopL: "(min-width: ".concat(BREAKPOINTS.laptopL, ")"),
  desktop: "(min-width: ".concat(BREAKPOINTS.desktop, ")"),
  desktopL: "(min-width: ".concat(BREAKPOINTS.desktop, ")")
};
exports.DEVICE = DEVICE;
var ICON_INFO = {
  color: 'greyMedium',
  fontSize: 'titleSmall',
  desktopIcon: 'InfoIcon',
  mobileIcon: 'ChevronRightIcon'
};
exports.ICON_INFO = ICON_INFO;
var TRANSLATION_DEFAULT = {
  'en-GB': {
    paymentMethodLabel: 'Change payment method',
    modal: {
      title: 'Change payment method',
      description: 'You can change how you want to pay for your purchases if you don’t want to use your default card'
    }
  }
};
exports.TRANSLATION_DEFAULT = TRANSLATION_DEFAULT;